import styled from "styled-components";

export const HomePageWrapper = styled.div`
  display: flex;
  /* flex: 1;
  */
  flex-direction: column;
  height: 100vh;
  /* width: 100%; */
  overflow: hidden;
  /* border: 1px solid brown; */
  .content_container {
    /* border: 2px solid brown; */
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    overflow: hidden;
  }
  div {
    box-sizing: border-box;
  }
  .page_container {
    /* border: 3px solid green; */
    height: 100%;
  }
`;
